import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Check, Upsell } from '@factorialco/f0-react/icons/app'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import useSubscribe from 'modules/core/hooks/useSubscribe'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { stringBySource } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/lib/stringBySource'
import { LandingSource } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/types'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

const EVENT_TYPE = 'fw_request_information_requested'

interface Props {
  source?: LandingSource
  buttonTexts?: {
    requested: string
    unlock: string
  }
  featureRequested: Features
}

export const RequestInfoButton = ({
  source = 'payrolldatalandingpage',
  featureRequested,
  buttonTexts = {
    requested: i18n.t('finance.financial_workspace.payroll.landing.buttons.requested'),
    unlock: i18n.t('upselling_kit.button.more_info'),
  },
}: Props) => {
  const [openModal, setOpenModal] = useState(false)
  const [requested, setRequested] = useLocalStorage<boolean>(
    'factorial:fwPayrollLandingRequest',
    false
  )

  // We are using this button in different places. As we have to change the status of all when
  // an user request data and the cookie state is not being listened, we are using this event to update
  // the status of all the buttons.
  useSubscribe([EVENT_TYPE], () => {
    setRequested(true)
  })

  if (featureRequested === Features.payroll_management) {
    return null
  }

  return (
    <Box data-testid={`payroll-request-info-button`}>
      <F0Button
        variant="outline"
        icon={requested ? Check : Upsell}
        label={requested ? buttonTexts.requested : buttonTexts.unlock}
        onClick={() => (requested ? {} : setOpenModal(true))}
        disabled={requested}
      />

      {openModal && (
        <UpsellingKit.ProductModal
          featureRequested={featureRequested}
          moduleRequested={AvailableModules.compensations}
          requestSource={`Financial Workspace - ${stringBySource(source)}`}
          requestReason={ValidReasons.Activation}
          pageSource={`Financial Workspace - ${stringBySource(source)}`}
          onClose={() => setOpenModal(false)}
          isOpen={openModal}
        />
      )}
    </Box>
  )
}
